import { Grid, Text } from '@ltvco/refresh-lib/theme';
import { useScreenSize } from '@ltvco/refresh-lib/utils';
import { FeatureCard } from '@ltvco/refresh-lib/v2';
import { ReactNode, useMemo } from 'react';

interface Feature {
  title: string;
  description: string;
  icon: ReactNode;
  action: () => void;
}

interface ExploreNewFeaturesProps {
  features: Feature[];
}

export const ExploreNewFeatures = ({ features }: ExploreNewFeaturesProps) => {
  const { isMobile } = useScreenSize();

  const featureCards = useMemo(
    () =>
      features.map((feature) => (
        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={feature.title}>
          <FeatureCard
            title={feature.title}
            description={feature.description}
            icon={feature.icon}
            action={feature.action}
            width={'100%'}
            height={120}
          />
        </Grid>
      )),
    [features]
  );

  return (
    <Grid container direction="column">
      <Grid>
        <Text variant="h3" mb={3} mt={2}>
          Explore New Features
        </Text>
      </Grid>
      <Grid container spacing={isMobile ? 1.5 : 2}>
        {featureCards}
      </Grid>
    </Grid>
  );
};
